import GongqiFormItemControl from './GongqiFormItemControl';
import StringUtil from '../../utils/StringUtil';
import AuthorityUtil from '../../utils/AuthorityUtil';
import GOTUtil from '../../utils/GOTUtil';
import GOT from '../../utils/GOT';
import FindForm from '../../utils/FindForm';
import FindForm2 from '../../utils/FindForm2';
import {GroupCurrentRecordChangedStore} from '../../stores/RecordsStore';
import {HeaderClickSortStore} from '../../stores/QueryStores';
import {CmdWriteControlStore} from '../../stores/CmdTypeStore';
import {CommandMapEditorsStore} from '../../stores/CommandStore';
import CmdTypeActions from '../../actions/CmdTypeActions';
import CommandActions from '../../actions/CommandActions';

import ControlPropertyConst from '../controlproperty/ControlPropertyConst';
import FormResourceUtil from '../../utils/FormResourceUtil';
import CommandResolver from '../../utils/CommandResolver';
import Warn from '../../utils/Warn';
import FormItemUtil from '../../utils/FormItemUtil';

import QueryUtil from '../../utils/QueryUtil';
import CommandHelper from '../../remote/CommandHelper';
import ServiceHelper from '../../remote/ServiceHelper';
import ValueCondition from '../../forms/sys/remote/ValueCondition';
import FormItemConst from '../FormItemConst';

import LayerManager from '../../manager/LayerManager';

export default class FormItemEditorControl extends GongqiFormItemControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemEditorControl";
		this.dataSource_Alias = this.xml.Properties.DataSource.Value;
		this.dataSource_Field =  this.xml.Properties.Extends.Value;
		this.record = null;
		var _group = null;
		this.isDataMethodField = false;
		this.isAggregate = false;
		if(this.xml.name && this.xml.name.indexOf("_Aggregate_") != -1)
		{
			this.isAggregate = true;
		}
        if(this.dataSource_Alias!="")
		{
			var _exfield = null;
			var _datasource = module.formDataSources.sources[this.dataSource_Alias];
			if(this.dataSource_Field != "")
			{
				_group = _datasource.group;
				//去找FormDataSourceField 后边会用到
				this.formDataSourceField = GOT.getFormDataSourceField(_datasource.xml,this.dataSource_Field);
			}
			else
			{
				var dataMethod = GOTUtil.getPropertyValue(this.xml,"DataMethod");
				if(dataMethod == "Normal" || dataMethod == "SelectRecords")
				{
					_exfield = StringUtil.convertToFirstLowerCase(this.xml.name);
					this.isDataMethodField = true;
					_group = _datasource.group;
					let _dataMethodDataField = this.dataSource_Alias + "." + _exfield;
					var _type = this.xml.type;
					_group.addTempDataMethodField(_dataMethodDataField,_dataMethodDataField,_type);
					_type = _type.substring(0, _type.length - "Editor".length);
					_datasource.addExtralFieldType(_exfield, _type);
					if(dataMethod == "SelectRecords")
						this.isDataMethodSelectRecords = true;
				}
			}
			
			if(_exfield != null) 
			{
				this.dataSource_Field = _exfield;
				this.dataField = this.dataSource_Alias + "." + _exfield;
			}
			
		}
		this.group = _group;this.groupAlias = this.group?this.group.groupAlias:"";

		let contextMenuItems = [];
		
		if(
			(this.isDataMethodField && this.group && group.mainSource.isTempTable)
			|| (!this.isDataMethodField && !this.isAggregate)
		)
        {
        	contextMenuItems.push(
	        	{label:'升序',icon:'',action:this.ascOrder.bind(this)},
	          	{label:'降序',icon:'',action:this.descOrder.bind(this)},
	            {label:'过滤[Ctrl+T]',icon:'',action:this.queryFilter.bind(this)},
	            {label:'应用到筛选[Ctrl+G]',icon:'',action:this.enterFind.bind(this)},
				{label:'查找[Ctrl+F]',icon:'',action:this.findValue.bind(this)},
				{label:'逐个查找[Ctrl+E]',icon:'',action:this.findValueStepByStep.bind(this)},
				{label:'跨列查找',icon:'',action:this.findValueStepByStepForMore.bind(this)}
        	);

        }
		
		if(window.isDataSetView){
			contextMenuItems.push(
				{label:'查找[Ctrl+F]',icon:'',action:this.findValue.bind(this)},
	            {label:'过滤[Ctrl+T]',icon:'',action:this.queryFilter.bind(this)}
	   		);
		}else{
			contextMenuItems.push(
					 {label:'查看记录详情[Ctrl+D]',icon:'',action:this.recordDetail.bind(this)},
					null, // divider
					//{label:'隐藏',icon:'',action:this.hide.bind(this)},
					//{label:'显示',icon:'',action:this.show.bind(this)},
					{label:'调整布局',icon:'',action:this.formAdjust.bind(this)}
					// {label:'画面调整(含列宽)',icon:'',action:this.formAdjust2.bind(this)}
			);
		}
		this.contextMenuData = {
		  items:contextMenuItems
		};
      
		this.unsubscribeGroupCurrentRecordChangedStore = GroupCurrentRecordChangedStore.listen(this.onCurrentRecordChanged.bind(this));
		this.unsubscribeHeaderClickSortStore = HeaderClickSortStore.listen(this.onHeaderClickSortHandler.bind(this));
		this.unsubscribeCmdWriteControlStore = CmdWriteControlStore.listen(this.onCmdWriteControlStore.bind(this));
		this.unsubscribeCommandMapEditorsStore = CommandMapEditorsStore.listen(this.onMapEditorsHandler.bind(this));

	}

	onCmdWriteControlStore(arg,moduleInstanceId)
	{
		if(arg && arg.hasOwnProperty(this.xml.name) && this.module.instanceUUId == moduleInstanceId)
		{
			var value = arg[this.xml.name];
			this.initEditorValue = value;
			this.hasInitEditorValue = true;
		}
	}

	onMapEditorsHandler(selector,mapEditorValues,moduleInstanceId)
	{
		if(this.component)
			return;
		if(!this.groupAlias && this.module.instanceUUId == moduleInstanceId)
		{
			if(selector!="all" && this.xml.name != selector)
				return;
			
			mapEditorValues[this.xml.name] = this.hasInitEditorValue?this.initEditorValue+"":this.getProperty_DefaultForCMD();
		}
		
	}

	doSetEnableCmd(value)
	{
		this._cmdEditFalse = !value;
		CmdTypeActions.updateControlAllowEdit(this.xml.name,value,this.moduleInstanceId);
	}

	setControlLabelCmd(value)
	{
		this._cmdLabel = value;
		CmdTypeActions.updateControlLabel(this.xml.name,value,this.module.instanceUUId);
	}

	setControlShowDecimalCmd(value)
	{
		this._cmdShowDecimal = value;
		CmdTypeActions.updateControlShowDecimal(this.xml.name,value,this.module.instanceUUId);
	}

	setControlSkipTabCmd(skip)
	{
		this._cmdSkipTab = skip;
	}

	getInitialLabel()
	{
		return this._cmdLabel?this._cmdLabel:this.getProperty_Label();
	}

	getInitialNotNull()
	{
		return this.propertyNotNull!=undefined?this.propertyNotNull:this.getProperty_NotNull();
	}

	getProperty_Label(showLabel = true)
	{
		if(showLabel && !this.getProperty_ShowLabel())
			return "";
		return super.getProperty_Label();
	}
	getProperty_ShowLabel()
	{
		return true;
		return this.properties.ShowLabel;
	}
	getProperty_EnumType()
	{
		return super.getProperty_EnumType();
	}

	pasteselect()
	{
		if(window.getSelection) {
		  alert(window.getSelection().toString());
		} else if(document.selection && document.selection.createRange) {
		  alert(document.selection.createRange().text);
		}
		return;
		document.execCommand("Copy","false",null);
	}

	copyselect()
	{
		document.execCommand("Copy","false",null);
	}
	
	doOrder(sortType=null)
	{
		if(!this.group)
			return;
		if(this.getISAggregate())
			return;
		if(this.isDataMethodField && !this.group.mainSource.isTempTable && !this.group.sortOnClient)
			return;
		var _dataField = this.getDataField();
		if(!_dataField)
			return;
		this.group.sort(_dataField,sortType,true,true);
	}
	onHeaderClickSortHandler(columnKey,sortDirection,moduleInstanceId)
	{
		if((this.dataField==columnKey || this.groupAlias+"."+this.dataSource_Field == columnKey) && this.module.instanceUUId == moduleInstanceId)
		{
			this.doOrder(sortDirection);		
		}
	}
	ascOrder()
	{

		this.doOrder("ASC");
	}

	descOrder()
	{
		this.doOrder("DESC");
	}

	queryFilter()
	{
		if(!this.group)
			return;
		if(this.getISAggregate())
			return;
		var _dataField = this.getDataField();
		if(_dataField && this.record && this.record.hasOwnProperty(_dataField))
		{
			var value = this.record[_dataField];
			this.group.queryFilter(_dataField,value);
		}
	}

	enterFind()
	{
		if(this.getISAggregate())
			return;
		let _dataField = this.getDataField();
		QueryUtil.findOrCreateWhereItem(_dataField,this.group.currentQuery);
		window.queryOpen('enterFind');
		//alert(this.getProperty_Label());
	}

	findValueStepByStep(flag='')
	{
		if(this.getISAggregate())
			return;

		if(!flag || flag !='findMore'){
			FindForm2.show(this.findValueStepByStepHandler.bind(this),this.getProperty_Label(),
								this.getDataField(),{type:this.xml.type,innerId:this.xml.id,entityId:this.formId},);
		}else{
			FindForm2.show(this.findValueStepByStepHandler.bind(this),this.getProperty_Label(),
			this.getDataField(),{type:this.xml.type,innerId:this.xml.id,entityId:this.formId},'serchMore');
		}
	}
	findValueStepByStepForMore(){
		if(this.getISAggregate())
		return;

		FindForm2.show(this.findValueStepByStepHandler.bind(this),this.getProperty_Label(),
		this.getDataField(),{type:this.xml.type,innerId:this.xml.id,entityId:this.formId},'serchMore');
	
	}

	findValueStepByStepHandler(text,fromIndex,stepColumn,pre=false)
	{
		if(this.group)
		{
			let dataFields;
			if(stepColumn == true)
			{
				let gridControl = this.parentControl;
				if(gridControl.classAlias != "FormItemDataGridControl")
				{
					gridControl = gridControl.parentControl;
				}
				let columns = gridControl._columns;
				dataFields = [];
				for(let i = 0;i<columns.length;i++)
				{
					let column = columns[i];
					if(column.width != 0.1)
					{
						dataFields.push(column.key);
					}
				}
			}

			if(pre == false)
			{
				return this.group.findValueStepByStep({dataFields:dataFields,value:text,dataField:this.getDataField(),fromIndex:fromIndex,stepColumn:stepColumn});
			}
			else
			{
				return this.group.findValueStepByStepPre({dataFields:dataFields,value:text,dataField:this.getDataField(),fromIndex:fromIndex,stepColumn:stepColumn});
			}
			
		}
	}

	getISAggregate()
	{
		if(this.dataSource_Field 
			&& this.dataSource_Alias 
			&& this.group 
			&& this.group.formDataSources)
		{
			let dataSource = this.group.formDataSources.sources[this.dataSource_Alias];
			let xml = dataSource.xml;
			let dataSourceField = GOT.getFormDataSourceField(xml,this.dataSource_Field);
			if(!dataSourceField)
				return false;
			let aggregateV = GOTUtil.getPropertyValue(dataSourceField,"AggregateType");
			return aggregateV;
		}
		
	}

	findValue()
	{
		if(this.getISAggregate())
			return;
		if((this.isDataMethodField && this.group && this.group.mainSource.isTempTable)
					|| !this.isDataMethodField){
						FindForm.show(this.findValueHandler.bind(this),this.getProperty_Label(),
										this.getDataField(),{type:this.xml.type});

					}
		if(window.isDataSetView){
			FindForm.show(this.findValueHandler.bind(this),this.getProperty_Label(),
										this.getDataField(),{type:this.xml.type});
		}
		//alert(this.getProperty_Label());
	}

	findValueHandler(text)
	{
		let dataField = this.getDataField();
		if(this.group)
		{
			this.group.findValue(dataField,text);	
		}
	}

	hide()
	{
		alert(this.getProperty_Label());
	}

	recordDetail()
	{
		//alert(this.getProperty_Label());

		if(this.group)
		{
			var filter = [];
			for(var key in FormItemUtil.formItemControlsForFor)
			{
				let item = FormItemUtil.formItemControlsForFor[key];
				if(item.classAlias=="FormItemStringEditorControl" && item.getDisplayAsPassword())
				{
					var itemXML = item.xml;
					var dp = GOTUtil.getProperty(itemXML,"Extends");
					if(dp.hasOwnProperty("refinnerid"))
					{
						var _key = dp.refentityid + dp.refinnerid;
					}
					filter.push(_key);
				}
			}
			
			/*if(this.group.mainSource.isAggreateTable)
			{
				this.group.showCurRecTotalAggreateTable(filter);	
			}
			else
			{
				this.group.showCurRecTotal(filter);
			}*/
			let fieldName = this.dataSource_Field;
			this.group.showCurRecTotal(filter,{field:fieldName});
		}
	}

	show()
	{
		alert(this.getProperty_Label());
	}


	getProperty_DataMethod()
	{
		return this.properties.DataMethod;
	}

	getProperty_QuerySource()
	{
		return this.properties.QuerySource;
	}

	getProperty_Regular()
	{
		return this.properties.Regular;
	}

	getProperty_QueryField()
	{
		return this.properties.QueryField;
	}

	getProperty_DefaultForCMD()
	{
		return this.getProperty_Default();
	}

	getProperty_DisplayStyle()
	{
		if(this._castedDisplayStyle)
			return this._castedDisplayStyle;
		let _displayStyle = this.properties.DisplayStyle;
		try
		{
			_displayStyle = JSON.parse(_displayStyle);
		}
		catch(e)
		{

		}
		this._castedDisplayStyle = _displayStyle;
		return this._castedDisplayStyle;
	}

	getProperty_Alignment()
	{
		
		let displayStyle = this.getProperty_DisplayStyle();
		if(displayStyle && displayStyle.HorizontalAlignment)
			return displayStyle.HorizontalAlignment;
		if(this.properties.hasOwnProperty("Alignment"))
			return this.properties.Alignment;
		return "Center";
	}

	getProperty_VAlignment()
	{
		let displayStyle = this.getProperty_DisplayStyle();
		if(displayStyle && displayStyle.VerticalAlignment)
			return displayStyle.VerticalAlignment;
		return "";
	}

	getProperty_CSSStyle_Display()
	{
		let displayStyle = this.getProperty_DisplayStyle();

		//displayStyle = {cssStyle:{fontFamily:"微软雅黑",fontStyle:"italic",fontWeight:"bold",fontSize:20}};

		if(displayStyle && displayStyle.cssStyle)
			return displayStyle.cssStyle;
		return "";
	}	

	getDefaultValue()
	{
		var value = this.getProperty_Default();
		if(!value)
			value = "";
		return value;
	}

	getProperty_Default()
	{
		return this.properties.Default;
	}

	onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId,causeId,groupInstance)
	{
		if(this.groupAlias == groupAlias && this.group == groupInstance)
			this.record = currentRecord;
	}

	getDataField()
	{
		if(this.dataField != null)
			return this.dataField;
		let dataSource = this.dataSource_Alias;
		let extend = this.dataSource_Field;
		let strField;
		//插件内部节点带点号
		if(dataSource!="" && extend!="")
		{
			if(extend.indexOf(".")!=-1)//插件内部节点带点 如果包含.号
			{
				let ss = extend.split(".");
				
				if(ss.length == 2)//插件内部节点带点 如果只有一个. 则表明是维度
				{
					strField = StringUtil.convertToFirstLowerCase(ss[0]) + "." + StringUtil.convertToFirstLowerCase(ss[1])
				}
				else
				{
					strField = StringUtil.convertToFirstLowerCase(extend);
				}
			}
			else
			{
				strField = StringUtil.convertToFirstLowerCase(extend);
			}
			this.dataField = dataSource + "." + strField;
		}
		
		if((this.dataField == null || this.dataField==undefined) && dataSource != "")
		{
			let dataMethod = this.xml.Properties.DataMethod.Value;
			let start = dataMethod.charAt(0);
			if(start == "@")
			{
				this.dataField = dataSource + "." + StringUtil.convertToFirstLowerCase(dataMethod.substr(1));
			}
			else if(start == "%")
			{
				this.dataField = dataSource + "." + StringUtil.convertToFirstLowerCase(this.xml.name);
			}
		}
		return this.dataField;
	}

	validateNotNull()
	{
		var _dataField = this.getDataField();
		if(_dataField && this.group && this.group.currentRecord)
		{
			var value = this.group.currentRecord[_dataField];
			//TODO !0为true  0==""也为true Decimal等或许不用再覆盖
			if(value == undefined || value == null || value == "")
			{
				var _label = this.getProperty_Label();
				return _label;
			}
		}
		return null;
	}

	getSelfNotNull()
	{
		var key = this.formId+this.xml.id+ControlPropertyConst.NOTNULL;
		var notnull = window.controlProperties[key];
		if(notnull)
			return notnull;
		if(this.propertyNotNull != undefined && this.propertyNotNull == true)
			return true;
		if(!this.xml.Properties.hasOwnProperty("NotNull"))
			return false;
		var notnull = this.xml.Properties.NotNull.Value;
		if(typeof(notnull) == "string")
		{
			return notnull == "true"?true:false;
		}
		else
		{
			return notnull;
		}
		//return this.xml.Properties.NotNull.Value;
	}

	getProperty_NotNull()
	{
		if(this.group)
		{
			var mainSource = this.group.mainSource;
			if(mainSource.alias != this.dataSource_Alias)
				return false;	
		}
		var key = this.formId+this.xml.id+ControlPropertyConst.NOTNULL;
		var notnull = window.controlProperties[key];
		if(notnull)
			return notnull;
		if(!this.properties.hasOwnProperty("NotNull"))
			return false;
		notnull = this.properties.NotNull;
		if(typeof(notnull) == "string")
		{
			return notnull == "true"?true:false;
		}
		else
		{
			return notnull;
		}
	}

	getProperty_AllowEdit_CurrentRecordLocked()
	{
		if(this.isDataMethodField)
			return false;
		if(this.group && this.group.ds_AllowEdit == false)
			return true;
		if(this.group && this.group.isCurrentRecordLocked())
			return true;
		return false;
	}

	getProperty_AllowEdit_Final(_record)
	{
		var dataMethod = this.getProperty_DataMethod();
		if(dataMethod && dataMethod.charAt(0) == "#")
			return false;
		if(this.forLookup && this.group)
			return false;
		if(this.dataSource_Field && _record)
		{
			let externalArgs = [_record];
			if(this.group && this.group.linkGroup)
				externalArgs.push(this.group.linkGroup.currentRecord);
			let allowEdit = LayerManager.executeLayerMethod(this.module,this.group,"recordAllowEdit_"+this.dataSource_Field,externalArgs);
			if(typeof(allowEdit) != "undefined" && allowEdit == false)
				return false;
		}
		return super.getProperty_AllowEdit_Final();
	}

	getDefaultDisplayLength()
	{
		return 20;
	}

	getDisplayLengthWidth()
	{
		let _displayLength = this.getProperty_DisplayLength();//从后台获取的全局属性集里获取具体值 该值是经过计算的
			//this.props.xml.Properties.DisplayLength.Value;
		if(_displayLength == "")
			_displayLength = this.getDefaultDisplayLength();
		return _displayLength*FormItemConst.displayLength_EN + FormItemConst.displayLength_ENAddon;
	}

	getFormDataSourceField()
	{
		if(this.dataSource_Field == "" || this.dataSource_Alias == "")
			return null;
		var formDataSourceField = GOT.getFormDataSourceFieldByName(window.formXML,this.dataSource_Alias,this.dataSource_Field);
		return formDataSourceField;
	}
		

	getProperty_AllowEditOnCreate()
	{ 
		if(this.properties.hasOwnProperty("AllowEditOnCreate"))
			return this.properties.AllowEditOnCreate;
		if(this.properties.AllowEdit == FormItemConst.ALLOWEDIT_ONLYONCREATE)
			return true;
		return false;
	}

	getProperty_Visible_FieldAu()
	{
		var formDataSourceField = this.getFormDataSourceField();
		if(!formDataSourceField)
		{
			return true;
		}
		var value = GOTUtil.getPropertyValue(formDataSourceField,"Visible");
	
		if(value == "false")
			return false;
		let _formXML;
		if(this.forLookup)_formXML=GOT.getForm(this.formId);else _formXML = window.formXML;

		var formDataSource = GOT.getFormDataSource(_formXML,this.dataSource_Alias);
		if(!formDataSource)return;

		value = GOTUtil.getPropertyValue(formDataSource,"Visible");
		if(value == "false")
			return false;

		var finalValue = true;var isForbidden = false;var finalValueSetted = false;
		
		var au = AuthorityUtil.getXmlType2SCacheItem(
			this.authorityKey,
			formDataSourceField.id,"visible"
			); 
		
		if(au["isDefault"] == false)
		{
			finalValue = au["result"];
			finalValueSetted = true;
			isForbidden = au["isForbidden"];
		}

		
		if(isForbidden)
			return false;
		//TODO自定义下拉画面?
		au = AuthorityUtil.getXmlType2SCacheItem(
			this.authorityKey,
			formDataSource.id,
			"visible"
		);
				
		if(au["isDefault"] == false)
		{
			if(!finalValueSetted)
			{
				finalValue = au["result"];
				finalValueSetted = true;
			}
			isForbidden = au["isForbidden"];
		}
		
		if(isForbidden)
			return false;

		
		var formDataSources = window.formXML.FormDataSources;
		
		au = AuthorityUtil.getXmlType2SCacheItem(
			this.authorityKey,
			formDataSources.id,
			"visible"
		);

		if(au["isDefault"] == false)
		{
			if(!finalValueSetted)
			{
				finalValue = au["result"];
				finalValueSetted = true;
			}
			isForbidden = au["isForbidden"];
		}
		
		return finalValue && !isForbidden;		
	}

	getProperty_AllowEdit_FieldAu()
	{
		if(window.getIsQueryOnlyFromMenuItem() == true)
			return false;
		var formDataSourceField = this.getFormDataSourceField();
		if(!formDataSourceField)
		{
			return true;
		}
		
		var value = GOTUtil.getPropertyValue(formDataSourceField,"AllowEdit");
		if(value == "false")
			return false;
		
		var formDataSource = GOT.getFormDataSource(window.formXML,this.dataSource_Alias);
		if(!formDataSource)return;
		
		value = GOTUtil.getPropertyValue(formDataSource,"AllowEdit");
		if(value == "false")
			return false;
		
		if(this.group.mainSource.alias != formDataSource.name)
			return false;
		
		var finalValue = true;var isForbidden = false;var finalValueSetted = false;
		
		var au = AuthorityUtil.getXmlType2SCacheItem(
			(window.menuItemId&&window.menuItemId!="")?window.menuItemId:window.formXML.name,
			formDataSourceField.id,"edit"
			); 
		
		if(au["isDefault"] == false)
		{
			finalValue = au["result"];
			finalValueSetted = true;
			isForbidden = au["isForbidden"];
		}
	
		if(isForbidden)
			return false;
		
		au = AuthorityUtil.getXmlType2SCacheItem(
			(window.menuItemId&&window.menuItemId!="")?window.menuItemId:window.formXML.name,
			formDataSource.id,
			"edit"
		);
				
		if(au["isDefault"] == false)
		{
			if(!finalValueSetted)
			{
				finalValue = au["result"];
				finalValueSetted = true;
			}
			isForbidden = au["isForbidden"];
		}
		
		if(isForbidden)
			return false;
		
		var formDataSources = window.formXML.FormDataSources;
		
		au = AuthorityUtil.getXmlType2SCacheItem(
			(window.menuItemId&&window.menuItemId!="")?window.menuItemId:window.formXML.name,
			formDataSources.id,
			"edit"
		);

		if(au["isDefault"] == false)
		{
			if(!finalValueSetted)
			{
				finalValue = au["result"];
				finalValueSetted = true;
			}
			isForbidden = au["isForbidden"];
		}
		
		if(finalValueSetted)
			return finalValue && !isForbidden;
			
		return true;
	}

	getProperty_AllowEdit_GOTFinal()
	{
		var result = this.getProperty_AllowEdit_GOT();
		
		if(result == false)
		{
			if(this.group)
			{
				var recVersion = this.group.getCurRecVersion();
				if(isNaN(recVersion) == false && recVersion == -1)
				{
					result = this.getProperty_AllowEditOnCreate();
				}
			}
		}
		if(!result)
			return false;
		result = this.getProperty_AllowEdit_FieldAu();
		if(!result)
			return false;
		result = this.getProperty_AllowEdit_Loop();
		return result;
		
	}

	getProperty_Visible_GOTFinal()
	{
		var result = this.getProperty_Visible();
		if(!result)
			return false;
		result = this.getProperty_Visible_GOT();
		if(!result)
			return false;
		result = this.getProperty_Visible_FieldAu();
		if(!result)
			return false;
		//return result;
		result =  this.getProperty_Visible_Loop();
		
		return result;
	}

	getProperty_Label(showLabel = true)
	{
		if(showLabel && !this.getProperty_ShowLabel())
			return "";
		return super.getProperty_Label();
	}

	getProperty_QueryFilter()
	{
		return this.properties.QueryFilter;
	}

	getProperty_DisplayHeight()
	{
		return this.properties.DisplayHeight;
	}

	getProperty_DisplayLength()
	{
		var _parentWindow = window.parent.window;
		if(!this.forLookup && _parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId+"."+window.formId))
		{
			let _userProperties = _parentWindow.userProperties[window.menuItemId+"."+window.formId];
			let _properties = _userProperties[this.xml.id];
			if(_properties && (_properties.hasOwnProperty("displayLength") || _properties.hasOwnProperty("displaylength") ))
				return _properties["displayLength"] || _properties["displaylength"];
		}

		if(this.parentControl && this.parentControl.classAlias == "FormItemFieldGroupControl")
		{
			let displayLength = this.parentControl.getProperty_DisplayLength();
			if(displayLength && displayLength>0)
				return displayLength;
		}

		return this.properties.DisplayLength;
	}

	getQueryFilteredVaue(value)
	{
		if(value == "*")
			return value;
		var filter = this.getProperty_QueryFilter();
		if(filter == "")
			filter = "=";
		return filter=="="?value:(filter+value);
	}


	doModifiedEditor(oldValue,newValue,component)
	{
		if(!this.module)
			return;
		var editorName = this.xml.name;
		
		LayerManager.executeLayerMethod(this.module,this.group,"modifiedEditor_"+editorName);

		var mi = FormResourceUtil.getCommandArgMethodInfo("modifiedEditor_"+editorName,this.forLookup?"FormLookup":window.menuItemId,this.module.formId);
		if(mi)
		{
			if(mi.prefetch==true)
			{
				CommandResolver.resolve(mi.commandResult.tasks, this.module, this.group);
			}
			else
			{
				var defaultGroupAlias;
				if(this.group)
				{
					defaultGroupAlias = this.group.groupAlias;
				}
				else
				{
					if(this.module.formDataSources && this.module.formDataSources.firstGroup)
					{
						defaultGroupAlias = this.module.formDataSources.firstGroup.groupAlias;
					}
				}
				var arg = CommandResolver.getSendCmd(this.module, defaultGroupAlias, mi);		
				
				var command = CommandHelper.createFormInstance(this.module.formName,"doModifiedEditor","CommandResult");
				
				command.appendArg(editorName, "String").appendArg(oldValue+"", "Object").appendArg(newValue+"", "Object").appendArg(arg,"CommandArg");
				var _group = this.group;var _rpc_fault_doModifiedEditor = this.rpc_fault_doModifiedEditor.bind(this);var _module = this.module;
				var remoteArg = {
					command:command,
					resultFunction:function(data){CommandResolver.resolve(data.result.tasks, _module, _group);},
					faultFunction:function(data){_rpc_fault_doModifiedEditor(data, oldValue, newValue, component);}
				};
				ServiceHelper.addTokenWithCommand(remoteArg);
			}
		}
		/*TODO 何意?
		var formModuleEvent:FormModuleEvent = new FormModuleEvent(FormModuleEvent.MODULE_FORMREINIT,true);
		formModuleEvent.caller = fm;
		formModuleEvent.callereditor = editorName;
		formModuleEvent.callereditorNewValue = newValue;
		formModuleEvent.callereditorOldValue = oldValue;
		fm.dispatchEvent(formModuleEvent);
		*/
	}

	rpc_fault_doModifiedEditor(data, oldValue, newValue, component)
	{
		//TODO 此处data是否具有标准返回格式?

		var faultString;
		if(data && data.successButNot0)
		{
			faultString = data.errText;
			//Warning.show({text:data.errText,title:"画面初始查询失败"});
		}
		else
		{
			faultString = "可能是网络错误 请检查网络是否正常";
			//Warning.show({text:"请检查网络是否正常或联系管理员",title:"变更值失败"});
		}

		var info = "变更值失败：" + oldValue + " -> " + newValue + "<br/>" + "已恢复到：" + oldValue+ "<br/>" + "失败原因为：" + faultString;
		Warn.show({text:info,title:"此次操作未能成功"});
		this.record = oldValue;
		if(component && typeof(component.restoreValue) == "function")
			component.restoreValue(oldValue);
		return;
		if(this.component)
		{
			this.component.record = oldValue;
			this.component.setDisplayNoResolve(oldValue);
		}
	}

	isSkipTab()
	{
		if(this.isUnderQueryGroup())
		{
			let result = {};
			CommandActions.callComponentFunc(this.formId,this.xml.id,"getInQueryGroupNow",[],result);
			if(result.ret == false)
				return true;
		}
		
		//TODO折叠的Group要跳过焦点导航
		//if(getGroupParentFolded())
		//	return true;
		
		//TODO与Flex不一致 Flex端没有跳过隐藏的节点
		//if(!this.getProperty_Visible_FinalusersetLoopForSkip())
		//	return true;
		if(!this.getProperty_Visible_Final())
			return true;
		if(this.getProperty_ActualSkipTab())
			return true;
		if(this.getProperty_AllowEdit_Final() == false)
			return true;
		return false;
	}

	doFieldModifiedRemote(dataField,newValue,oldValue,record,comoponent,extralParms = {})
	{
		// if(this.group)
		// {
		// 	let arr = dataField.split(".");
		// 	let aliasName = arr[0];
		// 	let fieldName = arr[1];
		// 	let componentName = null;
		// 	if(arr.length>2)
		// 		componentName = arr[2];
		// 	extralParms.editorName = this.xml.name;
		// 	return this.group.doFieldModifiedRemote(aliasName,fieldName,componentName,oldValue,newValue,dataField,record,comoponent,extralParms);	
			
		// }
		// return true;
		if(this.group)
		{
			
			let arr = dataField.split(".");
			let aliasName = arr.shift();
			let fieldName;
			if(this.componentField)
			{
				fieldName = this.componentDim;
			}
			else
			{
				fieldName = arr.join(".");
			}
			let componentName = null;
			if(this.componentField)
				componentName = this.componentField;
			extralParms.editorName = this.xml.name;
			extralParms.formDataSourceField = this.formDataSourceField;
			return this.group.doFieldModifiedRemote(aliasName,fieldName,componentName,oldValue,newValue,dataField,record,comoponent,extralParms);	
			
		}
		return true;
		
	}

	setControlProperty(property,value)
	{
		if(property == ControlPropertyConst.DISPLAYLENGTH)
		{
			this.propertyDisplayLength = value;
			CmdTypeActions.updateControlProperty(this.xml.name,property,value,this.module.instanceUUId);
			return true;
		}
		else if(property == ControlPropertyConst.NOTNULL)
		{
			this.propertyNotNull = value;
			CmdTypeActions.updateControlProperty(this.xml.name,property,value,this.module.instanceUUId);
			return true;
		}
		else if(property == ControlPropertyConst.KEYDOWNEVNET)
		{
			this.propertyKeyDownEvent = value;
			return true;
		}
		return false;
	}

	analysisConditionSingleValue(value,valueCondition)
	{
		if(valueCondition == null)
			return true;
		if(value == null)
			return false;
		 if(!valueCondition.getSqlWhereStr)
      		valueCondition.getSqlWhereStr = ValueCondition.getSqlWhereStr;
		var ws = valueCondition.getSqlWhereStr();
		if(ws == "")
			return true;
		var wsa = ws.split(" ");
		var wsr = "";
		for(let i = 0;i<wsa.length;i++)
		{
			let s = wsa[i];
			if(s.indexOf("=") == -1)
			{
				wsr += s;
			}
			else
			{
				var fn = StringUtil.convertToFirstLowerCase(s.substring(0,s.indexOf("=")));
				var fv = s.substr(s.indexOf("=")+1);
				
				if(fn.indexOf(".") != 0) //fn == .fieldName
					continue;
				//var value:String = anyRecordValue(fn,null,item);
				//对于无数据源 fv即ValueConditionItem中的value 不可能出现. 
				//if(fv.indexOf(".") == 0)
				//	fv = anyRecordValue(fv,null,item);
				
				
				if(RecordUtil.analysisValue(value,fv))
				{
					wsr+="1";
				}
				else
				{
					wsr+="0";
				}
			}
			
		}
		
		return StringUtil.evalLEString(StringUtil.trimThrough(wsr));
	}

	getCommonProps()
	{
		return {defaultValueForCMD:this.getProperty_DefaultForCMD(),initEditorValue:this.initEditorValue,
				controlVisible:this.getProperty_Visible_Final(),hideInVisible:this.getProperty_HideInVisible(),
				textAlign:this.getProperty_Alignment(),holdFocus:this.holdFocus,height:this.getProperty_Height()};
	}

	getComponentInstanceForDataGrid(parent,forLookup)
	{
		
	}

	getRenderForDataGrid(forLookup)
	{

	}
	
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemEditorControl.js